module.exports = __webpack_public_path__ + "img/liwu.bc1797c8.png";